import React from 'react';
import { render, waitFor, fireEvent } from '@testing-library/react';

jest.mock('../../api', () => ({
  getPcoDetail: jest.fn(),
}));

import DetailModal from '../DetailModal';
import API from '../../api';

describe('DetailModal', () => {
  let defaultProps;

  beforeEach(() => {
    fetch.resetMocks();
    API.getPcoDetail.mockReset();
    defaultProps = {
      itemType: 'group',
      itemId: '123',
      siteUniqueName: 'test-site',
      onClose: jest.fn(),
    };
  });

  afterEach(() => {
    document.body.style.overflow = '';
  });

  it('shows loading state initially', () => {
    API.getPcoDetail.mockReturnValue(new Promise(() => {}));
    const { getByText } = render(<DetailModal {...defaultProps} />);
    expect(getByText('Loading...')).toBeInTheDocument();
  });

  it('renders group detail after loading', async () => {
    API.getPcoDetail.mockResolvedValue({
      data: { name: 'Test Group', group_type: 'Small Group' },
    });
    const { getByText } = render(<DetailModal {...defaultProps} />);
    await waitFor(() => {
      expect(getByText('Test Group')).toBeInTheDocument();
    });
  });

  it('renders event detail', async () => {
    API.getPcoDetail.mockResolvedValue({
      data: { name: 'Test Event', starts_at: '2024-01-15T10:00:00Z' },
    });
    const { getByText } = render(<DetailModal {...defaultProps} itemType="event" />);
    await waitFor(() => {
      expect(getByText('Test Event')).toBeInTheDocument();
    });
  });

  it('renders message detail with video', async () => {
    API.getPcoDetail.mockResolvedValue({
      data: { title: 'Sunday Sermon', video_url: 'https://example.com/video.mp4' },
    });
    const { getByText, container } = render(<DetailModal {...defaultProps} itemType="message" />);
    await waitFor(() => {
      expect(getByText('Sunday Sermon')).toBeInTheDocument();
      expect(container.querySelector('video')).toBeInTheDocument();
    });
  });

  it('shows error when fetch fails', async () => {
    API.getPcoDetail.mockRejectedValue(new Error('Network error'));
    const { getByText } = render(<DetailModal {...defaultProps} />);
    await waitFor(() => {
      expect(getByText('Failed to load details')).toBeInTheDocument();
    });
  });

  it('shows error when data is not found', async () => {
    API.getPcoDetail.mockResolvedValue({});
    const { getByText } = render(<DetailModal {...defaultProps} />);
    await waitFor(() => {
      expect(getByText('Not found')).toBeInTheDocument();
    });
  });

  it('calls onClose when close button is clicked', async () => {
    API.getPcoDetail.mockResolvedValue({ data: { name: 'Group' } });
    const { getByLabelText } = render(<DetailModal {...defaultProps} />);
    fireEvent.click(getByLabelText('Close'));
    expect(defaultProps.onClose).toHaveBeenCalled();
  });

  it('calls onClose when Escape is pressed', () => {
    API.getPcoDetail.mockReturnValue(new Promise(() => {}));
    render(<DetailModal {...defaultProps} />);
    fireEvent.keyDown(document, { key: 'Escape' });
    expect(defaultProps.onClose).toHaveBeenCalled();
  });

  it('calls onClose when backdrop is clicked', () => {
    API.getPcoDetail.mockReturnValue(new Promise(() => {}));
    const { container } = render(<DetailModal {...defaultProps} />);
    const backdrop = container.querySelector('.pco-modal-backdrop');
    fireEvent.click(backdrop);
    expect(defaultProps.onClose).toHaveBeenCalled();
  });

  it('sets body overflow to hidden on mount', () => {
    API.getPcoDetail.mockReturnValue(new Promise(() => {}));
    render(<DetailModal {...defaultProps} />);
    expect(document.body.style.overflow).toBe('hidden');
  });

  it('renders enrollment link for groups', async () => {
    API.getPcoDetail.mockResolvedValue({
      data: { name: 'Group', enrollment_url: 'https://example.com/join' },
    });
    const { getByText } = render(<DetailModal {...defaultProps} />);
    await waitFor(() => {
      expect(getByText('Join This Group')).toBeInTheDocument();
    });
  });
});
